import axios from "axios";
import { useMutation, useQueryClient } from "react-query";

export const  useUpdateWorkbenchData =({report}) => {
    const queryClient = useQueryClient();
    return useMutation({
      mutationFn: async ({body,config}) => {
        return axios.post(`${process.env.REACT_APP_API_URI}AssignTech`, body, config);
      },
      onSuccess: () => {
        queryClient.invalidateQueries(['workbench', report])
      }
    });
  }